export default "__VITE_ASSET__cIEuZues__"